import { isPlatformBrowser } from '@angular/common';
import {
  CUSTOM_ELEMENTS_SCHEMA,
  Component,
  ElementRef,
  Inject,
  PLATFORM_ID,
  ViewChild,
  ViewEncapsulation,
  afterNextRender,
} from '@angular/core';
import { SwiperOptions } from 'swiper/types';
import { MatIcon } from '@angular/material/icon';
@Component({
  selector: 'app-carousel',
  templateUrl: './carousel.component.html',
  styleUrls: ['./carousel.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [MatIcon],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CarouselComponent {
  @ViewChild('carouselSwiper') swiper!: ElementRef<any>;

  swiperConfig: SwiperOptions = {
    centeredSlides: true,
    roundLengths: true,
    navigation: true,
    loop: true,
    loopPreventsSliding: true,
    updateOnWindowResize: true,
    breakpoints: {
      240: {
        slidesPerView: 1,
        spaceBetween: 5,
      },
      480: {
        slidesPerView: 1,
        spaceBetween: 5,
      },
      640: {
        slidesPerView: 1,
        spaceBetween: 5,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 10,
      },
    },
    autoplay: {
      delay: 5000,
    },
    injectStyles: [
      `
				.swiper-button-prev {
					  left: 22px;
  					color: #CC3179;
				}

				.swiper-button-next {
						right: 22px;
  					color: #CC3179;
				}

        @media (max-width: 1024px) {
				  .swiper-button-next {
              right: 8px;
          }

          .swiper-button-prev {
            left: 8px;
          }
        }
			`,
    ],
  };

  clients: { name: string; img: string }[] = [
    {
      name: 'Antecipação de recebíveis',
      img: './assets/img/png/financiador_parceiro.png',
    },
    {
      name: 'Plataforma de negociações',
      img: './assets/img/png/nosso-proposito-broad.png',
    },
    {
      name: 'Contas escrow',
      img: './assets/img/png/envio-das-nfs-broad.png',
    },
    {
      name: 'Broadfactor Pay conta digital',
      img: './assets/img/png/dinheiro-na-conta.png',
    },
    {
      name: 'Antecipação de contratos do governo federal',
      img: './assets/img/png/1.png',
    },
    {
      name: 'Capital de giro para empresas',
      img: './assets/img/png/Group 2278.png',
    },
  ];

  constructor(@Inject(PLATFORM_ID) private _platformId: Object) {
    afterNextRender(() => {
      this.handleUpdateSwiperConfig();
    });
  }

  handleUpdateSwiperConfig(): void {
    if (isPlatformBrowser(this._platformId)) {
      this.swiperConfig = {
        ...this.swiperConfig,
        direction: 'horizontal',
      };
    }
    Object.assign(this.swiper.nativeElement, this.swiperConfig);
    this.swiper.nativeElement.initialize();
  }
}
